import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { jwtDecode } from "jwt-decode";
import axiosConn from "config/axiosConn";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import FacultySideBar from "./FacultySideBar";
import Langfield from "../../assets/Json/accountFormLang.json";
import Helper from "../../helper/Common_Helper";
import { changeLang, selectedVoice } from '../../redux/langSlice';
import { useDispatch } from 'react-redux';
import { FaBarsStaggered } from "react-icons/fa6";
import { Link, redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function EcoCalendar() {
    const [openSidebar, setOpenSidebar] = useState(false);
    const userData = useSelector(state => state.auth.user);
    // console.log("check",userData, "userData3");
    const [role, setRole] = useState("");
    const [eventsData, setEventsData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [langSelected, setLangSelected] = useState('en-IN');
    const [isMobileView, setIsMobileView] = useState(false); // Detect mobile view
    const translations = Langfield[langSelected];
    const dispatch = useDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768); // Define mobile view as width <= 768px
        };
        handleResize(); // Set initial state
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const translate = (key) => {
        if (typeof translations !== 'object' || translations === null) {
            return key;
        }
        if (typeof key !== 'string') {
            return key;
        }
        return translations[key] || key.replace(/_/g, ' ');
    };

    const getEventsForMonth = async (year, month) => {
        try {
            const response = await axiosConn('get', `events/month/${year}/${month}`);
            if (response.data.status === 'success') {
                setEventsData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    const renderEventContent = (eventInfo) => {
        const { event } = eventInfo;
        const isPastEvent = new Date(event.start) < new Date();
        const eventColor = event.extendedProps.userRole === "ministry" 
            ? "green" 
            : isPastEvent 
            ? "red" 
            : "blue";

        return (
            <div
                style={{
                    backgroundColor: isMobileView ? "white" : eventColor, // White background in mobile view
                    borderColor: eventColor,
                    padding: "6px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    textAlign: "center",
                    overflow: "hidden",
                    color: isMobileView ? eventColor : "#fff", // Color of the bullet points in mobile view
                }}
            >
                {isMobileView ? (
                    <span
                        style={{
                            color: eventColor, // Bullet point color
                            fontSize: "20px",
                            backgroundColor: "white", // White background for mobile view
                        }}
                    >
                        •
                    </span>
                ) : (
                    <>
                        <i>{event.title}</i>
                        <div>{event.extendedProps.theme_name}</div>
                        <div>{event.extendedProps.subtheme_name}</div>
                    </>
                )}
            </div>
        );
    };

    useEffect(() => {
        // console.log("userdata343434343434343434,",userData);
        if (userData) {
            setLangSelected(userData.lang)
            setRole(userData.role);
        }
    }, [userData]);

    const handleEventClick = (clickInfo) => {
        setSelectedEvent(clickInfo.event);
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);
    const handleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const handleDatesSet = (dateInfo) => {
        const startDate = dateInfo.startStr;
        const endDate = dateInfo.endStr;
        getEventsForDateRange(startDate, endDate);
    };

    const getEventsForDateRange = async (startDate, endDate) => {
        try {            
            const formattedStart = new Date(startDate).toISOString();
            const formattedEnd = new Date(endDate).toISOString();

            const response = await axiosConn('get', `events/range?start=${encodeURIComponent(formattedStart)}&end=${encodeURIComponent(formattedEnd)}&udise_id=${userData.udise_id}`);
            if (response.data.status === 'success') {
                setEventsData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    return (
        <>
            <section className="scholdashbrdSec">
                <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
                    <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
                </div>
                <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
                    <FacultySideBar langSelected={langSelected} index={4} role={role} />
                </div>
                <div className="schlDashbrdRgt">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="card-user pageContainer">
                                <div className="card-header pgHederSpceArnd">
                                    <h5 className="card-title">{translate("Eco Calendar")}</h5>
                                </div>
                                <div className="viewThemeDiv">
                                    <FullCalendar
                                        plugins={[dayGridPlugin]}
                                        initialView="dayGridMonth"
                                        weekends={true}
                                        events={eventsData}
                                        eventContent={renderEventContent}
                                        eventClick={handleEventClick}
                                        datesSet={handleDatesSet}
                                    />
                                </div>
                                <div
                                    className="checkboxes"
                                    style={{
                                        textAlign: "center",
                                        marginTop: "20px",
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "20px",
                                    }}
                                >
                                    <label
                                        className="custom-checkbox"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="ministryEvents"
                                            disabled
                                            style={{ display: "none" }}
                                        />
                                        <div
                                            className="checkbox-box"
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                marginRight: "10px",
                                                borderRadius: "4px",
                                                backgroundColor: "green",
                                            }}
                                        ></div>
                                        Ministry Events
                                    </label>
                                    <label
                                        className="custom-checkbox"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="pastEvents"
                                            disabled
                                            style={{ display: "none" }}
                                        />
                                        <div
                                            className="checkbox-box"
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                marginRight: "10px",
                                                borderRadius: "4px",
                                                backgroundColor: "red",
                                            }}
                                        ></div>
                                        Past Events
                                    </label>
                                    <label
                                        className="custom-checkbox"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="futureEvents"
                                            disabled
                                            style={{ display: "none" }}
                                        />
                                        <div
                                            className="checkbox-box"
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                marginRight: "10px",
                                                borderRadius: "4px",
                                                backgroundColor: "blue",
                                            }}
                                        ></div>
                                        Future Events
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Event Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {selectedEvent && (
                        <>
                            <p><strong>Name of the event :</strong> {selectedEvent.title}</p>
                            <p><strong>Theme :</strong> {selectedEvent.extendedProps.theme}</p>
                            <p><strong>Subtheme :</strong> {Array.isArray(selectedEvent.extendedProps.subtheme) ? selectedEvent.extendedProps.subtheme.join(", ") : selectedEvent.extendedProps.subtheme}</p>
                            <p><strong>Date :</strong> {Helper.formatDate(selectedEvent.start)}</p>
                            <p><strong>Blocked by :</strong> {selectedEvent.extendedProps.userRole}</p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EcoCalendar;
